import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { useActionsContext, useFiltersContext } from "./context";
import type { FilterTypeConfig } from "./types";

/**
 * Setter for filters edited inside the main dropdown panel. Writes to the
 * shared pending buffer; the buffer flushes on dropdown close. Custom
 * `onClear` handlers commit immediately and drop the touched mark so the
 * close-time flush doesn't republish a stale pre-clear value over the
 * just-applied default.
 */
export function useDropdownFilterSetter(filterConfig) {
  const $ = _c(4);
  const {
    updatePending,
    dropTouched
  } = useActionsContext();
  let t0;
  if ($[0] !== dropTouched || $[1] !== filterConfig || $[2] !== updatePending) {
    t0 = value => {
      if (value === undefined && filterConfig.onClear) {
        filterConfig.onClear();
        dropTouched(filterConfig.filterKey);
        return;
      }
      updatePending(filterConfig.filterKey, value);
    };
    $[0] = dropTouched;
    $[1] = filterConfig;
    $[2] = updatePending;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}

/**
 * Setter for inline filter pills. Each pill has its own per-pill blur-publish
 * flow (see `<TableFilter mode="inline">`); writes commit through to the
 * parent's `onFilterChange` directly.
 */
export function useInlineFilterSetter(filterConfig) {
  const $ = _c(3);
  const {
    commitImmediate
  } = useActionsContext();
  useFiltersContext();
  let t0;
  if ($[0] !== commitImmediate || $[1] !== filterConfig) {
    t0 = value => {
      if (value === undefined && filterConfig.onClear) {
        filterConfig.onClear();
        return;
      }
      commitImmediate(filterConfig.filterKey, value);
    };
    $[0] = commitImmediate;
    $[1] = filterConfig;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}